import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <Container className="my-3 text-center">
      <h1>Unauthorized</h1>
      <br />
      <p>You do not have access to the requested page.</p>
      <Button variant="primary" onClick={goBack}>
        Go Back
      </Button>
    </Container>
  );
};

export default Unauthorized;
